module.exports = __webpack_public_path__ + "static/utm-8f8f20ec106113b4c46228e96b36597e.png";